import React from "react";

import MDInput from "materialDashboard/components/MDInput";
import Autocomplete from "@mui/material/Autocomplete";
import {useTranslation} from "react-i18next";


const StationVisibilityAutocomplete = ({ setStationVisibility, inputProps={}, ...props }) => {
    const {t} = useTranslation("inputs");

    const stationTypeOptions = ["PUBLIC", "SHARED", "PRIVATE"];
    const stationTypeLabels = {
        PUBLIC: t(`enums:stationVisibility.PUBLIC`),
        SHARED: t(`enums:stationVisibility.SHARED`),
        PRIVATE: t(`enums:stationVisibility.PRIVATE`),
    }

    return <Autocomplete
        id="role-autocomplete"
        options={stationTypeOptions}
        getOptionLabel={(o) => stationTypeLabels[o]}
        filterOptions={(x) => x}
        onChange={(e, value) => setStationVisibility(value)}
        renderInput={(params) => (
            <MDInput {...params}
                     variant="standard"
                     label={t('stationVisibilityAutocomplete.label')}
                     placeholder={t('stationVisibilityAutocomplete.placeholder')}
                     {...inputProps}
            />
        )}
        {...props}
    />
}

export default StationVisibilityAutocomplete;